import { useState } from "react";
import { useUI } from "../store/ui";
import { PERSONAS } from "../data/org";

function fmt(ts: number) {
  return new Date(ts).toLocaleString("pt-BR", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit"
  });
}

export function MeetingsArchive() {
  const saved      = useUI(s => s.savedMeetings);
  const del        = useUI(s => s.deleteMeeting);
  const [openId, setOpenId] = useState<string | null>(null);

  const open = saved.find(m => m.id === openId);

  return (
    <div className="px-8 pb-16">
      <header className="border-2 border-ink bg-ink text-bone px-5 py-4 mb-4">
        <div className="font-mono text-xs text-gold">ARQ-01</div>
        <h2 className="font-display font-black uppercase text-4xl leading-none">REUNIÕES SALVAS</h2>
        <div className="font-serif italic mt-1 text-bone/70">
          {saved.length} {saved.length === 1 ? "registro" : "registros"} · ata + conselho
        </div>
      </header>

      {saved.length === 0 ? (
        <div className="border-2 border-graymd p-10 text-center font-serif italic text-paper">
          Nenhuma reunião salva. Gere uma pauta em "Sala de reunião" e clique em <span className="font-mono not-italic">↳ salvar</span>.
        </div>
      ) : (
        <div className="grid lg:grid-cols-2 gap-3">
          {saved.map(m => {
            const isOpen = m.id === openId;
            return (
              <div key={m.id} className={`border-2 ${isOpen ? "border-red" : "border-ink"} bg-bone`}>
                <div className="px-4 py-3 border-b border-ink/30 flex items-start justify-between gap-2">
                  <div className="flex-1 min-w-0">
                    <div className="tag text-graydk">
                      {fmt(m.createdAt)} · {m.mode === "conselho" ? "modo conselho" : "modo ata"}
                    </div>
                    <div className="font-display font-bold uppercase text-xl leading-tight">
                      {m.title}
                    </div>
                    <div className="font-crimson italic text-sm text-paper mt-1">
                      {m.picks.length} participantes ·{" "}
                      {m.picks.slice(0, 4).map(id => PERSONAS.find(p => p.id === id)?.name).filter(Boolean).join(", ")}
                      {m.picks.length > 4 ? "…" : ""}
                    </div>
                  </div>
                  <div className="flex flex-col gap-1 shrink-0">
                    <button onClick={() => setOpenId(isOpen ? null : m.id)} className="btn btn-fire">
                      {isOpen ? "fechar" : "abrir"}
                    </button>
                    <button
                      onClick={() => { if (confirm("Apagar esta reunião?")) del(m.id); }}
                      className="btn btn-fire hover:bg-red hover:text-bone">apagar</button>
                  </div>
                </div>
                {isOpen && (
                  <pre className="p-4 font-mono text-[13px] whitespace-pre-wrap leading-relaxed">
{m.agenda.join("\n")}
                  </pre>
                )}
              </div>
            );
          })}
        </div>
      )}

      {open && (
        <div className="mt-6 flex gap-2">
          <button
            onClick={() => navigator.clipboard.writeText(open.agenda.join("\n"))}
            className="btn btn-fire">copiar ata aberta</button>
        </div>
      )}
    </div>
  );
}
